import APIRestfulProvider from "../../restful-provider"
import TenantVisitorServices from "./visitor"
import TenantUserManagement from "./user"
import TenantGeneralService from "./general"
import TenantPermissionControlServices from "./permission"

/**
 * Tenant Services Endpoint
 */

class TenantServiceEndpoints {

    visitor: TenantVisitorServices
    user: TenantUserManagement
    general: TenantGeneralService
    permission: TenantPermissionControlServices

    constructor(provider: APIRestfulProvider) {
        this.visitor = new TenantVisitorServices(provider)
        this.user = new TenantUserManagement(provider)
        this.general = new TenantGeneralService(provider)
        this.permission = new TenantPermissionControlServices(provider)
    }

}


export default TenantServiceEndpoints